import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Save, FileText } from 'lucide-react';
import { apiService } from '../../services/api';

const PixDebitosCard = () => {
  const [form, setForm] = useState({ chave_pix: '', nome_beneficiario: '', nome_banco: '' });
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const r = await apiService.api.get('/sistema/dados-cobranca-debitos');
        setForm({
          chave_pix: r.data?.chave_pix || '',
          nome_beneficiario: r.data?.nome_beneficiario || '',
          nome_banco: r.data?.nome_banco || '',
        });
      } catch (_e) {
        // mantém vazio
      } finally {
        setCarregando(false);
      }
    })();
  }, []);

  const salvar = async () => {
    const chave = form.chave_pix.trim();
    const benef = form.nome_beneficiario.trim();
    const banco = form.nome_banco.trim();
    if (!chave || !benef || !banco) {
      alert('Preencha os 3 campos: chave PIX, nome do beneficiário e nome do banco.');
      return;
    }
    setSalvando(true);
    try {
      await apiService.api.put('/sistema/dados-cobranca-debitos', {
        chave_pix: chave, nome_beneficiario: benef, nome_banco: banco,
      });
      alert('PIX dos débitos salvo!');
    } catch (e) {
      alert('Erro ao salvar: ' + (e?.response?.data?.detail || e.message));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Card data-testid="card-pix-debitos" className="border-2 border-orange-500/40 bg-orange-50/5">
      <CardHeader className="bg-orange-500/10">
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center space-x-2">
            <FileText className="h-5 w-5 text-orange-500" />
            <span>PIX dos Débitos / Multas</span>
          </span>
          <span className="text-[10px] uppercase font-bold bg-orange-500 text-white px-2 py-1 rounded-full tracking-wider">
            PIX Separado
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-4">
        <div className="bg-orange-50/10 border border-orange-500/30 rounded-lg p-3">
          <p className="text-sm text-gray-200">
            ⚠️ Esta chave PIX é usada <strong className="text-orange-300">APENAS para débitos e multas</strong> do cliente
            (parcelas extras de multa de trânsito, reposição de peças, etc).
          </p>
          <p className="text-xs text-gray-400 mt-2">
            • Aparece na tela &ldquo;Pagar débito&rdquo; do app do cliente como bloco amarelo.<br />
            • É <strong>diferente</strong> da chave PIX do aluguel — o cliente faz 2 PIX separados.<br />
            • Se nenhuma chave for configurada, usa o fallback: <code className="bg-slate-800 px-1 rounded">60.231.475/0001-10</code> (Desloca LTDA).
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <Label>Chave PIX</Label>
            <Input
              data-testid="input-pix-debitos-chave"
              placeholder="Ex.: 60.231.475/0001-10"
              value={form.chave_pix}
              onChange={(e) => setForm({ ...form, chave_pix: e.target.value })}
              disabled={carregando}
            />
          </div>
          <div>
            <Label>Nome do Beneficiário</Label>
            <Input
              data-testid="input-pix-debitos-beneficiario"
              placeholder="Ex.: Desloca LTDA"
              value={form.nome_beneficiario}
              onChange={(e) => setForm({ ...form, nome_beneficiario: e.target.value })}
              disabled={carregando}
            />
          </div>
          <div>
            <Label>Banco</Label>
            <Input
              data-testid="input-pix-debitos-banco"
              placeholder="Ex.: Bradesco"
              value={form.nome_banco}
              onChange={(e) => setForm({ ...form, nome_banco: e.target.value })}
              disabled={carregando}
            />
          </div>
        </div>

        <div className="flex justify-end">
          <Button
            data-testid="btn-salvar-pix-debitos"
            onClick={salvar}
            disabled={salvando || carregando}
            className="bg-orange-600 hover:bg-orange-700"
          >
            <Save className="h-4 w-4 mr-2" />
            {salvando ? 'Salvando...' : 'Salvar'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default PixDebitosCard;
